module.exports = __webpack_public_path__ + "img/Maritime_fre_1.c36f6958.jpg";